import { application } from './application'

import ChartController from './chart_controller'
application.register('chart', ChartController)

import Notification from '@stimulus-components/notification'
application.register('notification', Notification)

import MessagesListController from '../../controllers/messages_list_controller'
application.register('messages-list', MessagesListController)

import { ScrollToBottomController } from '../../controllers/scroll_to_bottom_controller'
application.register('scroll-to-bottom', ScrollToBottomController)

import { AutosizeController, TimeDistanceController } from 'stimulus-library'
application.register('autosize', AutosizeController)
application.register('time-distance', TimeDistanceController)

import MessageComposerController from './message_composer_controller'
application.register('message-composer', MessageComposerController)

import NotificationsController from './notifications_controller'
application.register('notifications', NotificationsController)

import FireworksController from '../../controllers/fireworks_controller'
application.register('fireworks', FireworksController)
